/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const usualBreakfast = useStore((state) => state.usualBreakfast);
  const setUsualBreakfast = useStore((state) => state.setUsualBreakfast);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.usualBreakfast.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={usualBreakfast}
          onChange={(value: string) => {
            setUsualBreakfast(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'usual-breakfast',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Just coffee'}>
            <span>☕</span>
            {t('onboarding.usualBreakfast.options.justCoffee')}
          </Option>
          <Option value={'Eggs and toast'}>
            <span>🍳</span>
            {t('onboarding.usualBreakfast.options.eggsAndToast')}
          </Option>
          <Option value={'Something sweet'}>
            <span>🥐</span>
            {t('onboarding.usualBreakfast.options.sweet')}
          </Option>
          <Option value={'I usually skip it'}>
            <span>❌</span>
            {t('onboarding.usualBreakfast.options.usuallySkip')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
